/**
 * unit-status — a 8-state `EquipmentUnitStatus` szín- + label-map (badge + timeline forrása).
 *
 * Külön (nem-komponens) modul a `package-admin-resolve` mintára: a `StatusBadge` (`@kgc/ui`) csak
 * 4 equipment-statet ismer, a kanonikus enum 8-state → FE-map a teljes 8-ra. A label i18n-ből.
 */
import type { EquipmentUnitStatus } from '@kgc/equipment-type-domain';

/** Status → Tailwind badge-osztály (light + dark), a meglévő EQUIPMENT_STATUS_COLORS mintára. */
export const UNIT_STATUS_COLORS: Record<EquipmentUnitStatus, string> = {
  AVAILABLE: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  RESERVED: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300',
  IN_USE: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  DAMAGED: 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300',
  UNDER_REPAIR: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  SOLD: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300',
  WITHDRAWAL_REQUESTED: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
  RETIRED: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
};

export function unitStatusLabelKey(status: EquipmentUnitStatus): string {
  return `equipmentUnit.status.${status}`;
}
